import 'mapbox-gl/dist/mapbox-gl.css'
import owasp from 'owasp-password-strength-test'
import React, { Suspense } from 'react'
import 'react-image-crop/src/ReactCrop.scss'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import { initializeTheme } from './components/DashboardLayout/hooks/theme'
import { LoadingScreen } from './components/LoadingScreen/LoadingScreen'
import { ROUTES } from './constants/routes'
import { PaymentConfirm } from './pages/Financials/pages/PaymentConfirm/PaymentConfirm'
import './styles/custom.scss'

owasp.config({
  allowPassphrases: true,
  maxLength: 72,
  minLength: 8,
  minOptionalTestsToPass: 4,
  minPhraseLength: 20,
})

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount: number, error: unknown) => {
        const isHttpError = typeof error === 'object' && !!error && 'code' in error
        if (isHttpError && error.code === 401 && failureCount < 1) {
          return true
        }
        return false
      },
    },
  },
})

initializeTheme()

export const AppRoutes = React.lazy(() =>
  import('./AppRoutes').then((module) => ({
    default: module.AppRoutes,
  })),
)

export const App = (): React.ReactElement => {
  return (
    <div id="citrus-app">
      <QueryClientProvider client={queryClient}>
        <Router>
          <Routes>
            {window.top !== window && (
              <Route path={ROUTES.FINANCIALS_PAYMENT_CONFIRM} element={<PaymentConfirm />} />
            )}
            <Route
              index={true}
              path="*"
              element={
                <>
                  <Suspense fallback={<LoadingScreen />}>
                    <AppRoutes />
                  </Suspense>
                  <ReactQueryDevtools
                    initialIsOpen={false}
                    position="bottom-right"
                    toggleButtonProps={{ style: { right: '0.5rem', bottom: '0.2rem' } }}
                    closeButtonProps={{ style: { right: '0.5rem', bottom: '0.5rem' } }}
                  />
                </>
              }
            />
          </Routes>
        </Router>
      </QueryClientProvider>
    </div>
  )
}
